import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { AgentService } from '../services/agent.service';

@Component({
  selector: '',
  template: '',
})
export class AgentPartyContactHandlerComponent extends BaseComponent<AgentService> implements OnChanges {
  public partyModel: any;

  constructor(agentService: AgentService) {
    super(agentService);
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }
}
